import Util from '../util';
import { getTempInfo } from '../common.js';
import { Toast } from 'antd-mobile/lib';
import { cleanCache } from '../action/loginAction';
export function pageFlag(text){
  return {
    type:"PAGE_FLAG",
    text:text
  }
}
export function choseKeyPasswordVal(text){
  return {
    type:"KEY_PASSWORD_VAL",
    text:text
  }
}

export function chosePageFlag(data){
  return function(dispatch, getState){
    dispatch(pageFlag(false))
  }
}
export function chosePassWordKeyBoard(text){
  return {
    type:"PASSWORD_KEYBOARD",
    text:text
  }
}
export function choseLoginShowHide(text){
  return {
    type:"LOGIN_SHOW_HIDE",
    text:text
  }
}

//state
export function myOpenFlag(text){
  return {
    type:"OPEN_FLAG",
    text:text
  }
}
export function myActive(text){
  return {
    type:"ACTIVE",
    text:text
  }
}
export function myAddCardText(text){
  return {
    type:"ADD_CARD_TEXT",
    text:text
  }
}
export function myAddPhoneText(text){
  return {
    type:"ADD_PHONE_TEXT",
    text:text
  }
}
export function myPaymentText(text){
  return {
    type:"PAYMENT_TEXT",
    text:text
  }
}
export function myPaymentTextDT(text){
  return {
    type:"PAYMENT_TEXT_DT",
    text:text
  }
}
export function myPaymentAgree(text){
  return {
    type:"PAYMENT_AGREE",
    text:text
  }
}
export function myFee(text){
  return {
    type:"FEE",
    text:text
  }
}
export function myPhoneNum(text){
  return {
    type:"PHONE_NUM",
    text:text
  }
}
export function myVerifyCode(text){
  return {
    type:"VERIFY_CODE",
    text:text
  }
}
export function mySyncLoginPWD1(text){
  return {
    type:"SYNC_LOGIN_PWD1",
    text:text
  }
}
export function mySyncLoginPWD2(text){
  return {
    type:"SYNC_LOGIN_PWD2",
    text:text
  }
}
export function mySyncDealPWD1(text){
  return {
    type:"SYNC_DEAL_PWD1",
    text:text
  }
}
export function mySyncDealPWD2(text){
  return {
    type:"SYNC_DEAL_PWD2",
    text:text
  }
}
export function mySyncBtn(text){
  return {
    type:"SYNC_BTN",
    text:text
  }
}







// WEBPACK FOOTER //
// ./src/action/publicAction.js